export const environment = {
    production: true,
    name: 'Staging',
    apiUrl: "https://manager-residenz-sta.chapps.com/",
    accountSiteUrl: 'https://account-sta.chapps.com/',
    zendeskUrl: 'https://chapps.freshdesk.com/',
    residenzSiteUrl: 'https://residenz-sta.chapps.com',
    buildingManagerUrl: 'https://building-sta.chapps.com',
  
    features: {
      spf: true
    }
  };
  